(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["box-expandable-content"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var boxExpandableContentSwiper = null;
    var boxExpandableContentEl = document.querySelector(".box-expandable-content__box-items");
    
    function initSwiper() {
      // Only initialize Swiper on mobile (768px and below)
      if (window.innerWidth <= 768) {
        // Destroy existing Swiper if it exists
        if (boxExpandableContentSwiper) {
          boxExpandableContentSwiper.destroy(true, true);
          boxExpandableContentSwiper = null;
        }
        
        boxExpandableContentSwiper = new Swiper(boxExpandableContentEl, {
          slidesPerView: 1.2,
          spaceBetween: 16,
          freeMode: false,
          resistance: true,
          resistanceRatio: 0.85,
          slidesOffsetAfter: 16,
        });
      } else {
        // Destroy Swiper if window is resized to desktop
        if (boxExpandableContentSwiper) {
          boxExpandableContentSwiper.destroy(true, true);
          boxExpandableContentSwiper = null;
        }
      }
    }
    
    // Initialize on load
    initSwiper();
    
    // Re-initialize on resize
    let resizeTimer;
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function() {
        initSwiper();
      }, 250);
    });
    
    // Handle button clicks to toggle active states
    function handleButtonClick(button) {
      // Get the data-content-id from the clicked button
      var contentId = button.getAttribute('data-content-id');
      if (!contentId) return;
      
      // Get the parent box-item (swiper-slide)
      var parentBoxItem = button.closest('.box-expandable-content__box-item.swiper-slide');
      if (!parentBoxItem) return;
      
      // Get all content items
      var allContentItems = document.querySelectorAll('.box-expandable-content__box-item-content');
      var targetContentItem = document.getElementById(contentId);
      
      // Check if clicking the same button (toggle off)
      var isCurrentlyActive = parentBoxItem.classList.contains('active');
      
      // Remove 'active' class from all box-items
      var allBoxItems = document.querySelectorAll('.box-expandable-content__box-item.swiper-slide');
      allBoxItems.forEach(function(item) {
        item.classList.remove('active');
      });
      
      // Remove 'active' class from all content items
      allContentItems.forEach(function(item) {
        if (item.classList.contains('active')) {
          // Reset animations by removing active class
          item.classList.remove('active');
          // Force reflow to reset animation state
          void item.offsetHeight;
        }
      });
      
      // If not the same button, activate the new one
      if (!isCurrentlyActive && targetContentItem) {
        // Add 'active' class to the clicked button's parent
        parentBoxItem.classList.add('active');
        
        // Small delay to ensure display is set before animation
        requestAnimationFrame(function() {
          // Add 'active' class to the content item with matching ID
          targetContentItem.classList.add('active');
        });
      }
    }
    
    // Add click event listeners to all buttons
    var buttons = document.querySelectorAll('.box-expandable-content__box-item');
    buttons.forEach(function(button) {
      button.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        handleButtonClick(button);
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fc-about-us-hero"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.fc-about-us-hero__video-wrapper').forEach(function (wrapper) {
    var video = wrapper.querySelector('.fc-about-us-hero__video-element');
    var btn = wrapper.querySelector('.fc-about-us-hero__play-btn');
    if (!video || !btn) return;

    function toggleVideo() {
      if (video.paused) {
        video.style.display = 'block';
        video.play();
        btn.classList.add('fc-about-us-hero__play-btn--playing');
        btn.classList.remove('fc-about-us-hero__play-btn--paused');
      } else {
        video.pause();
        btn.classList.remove('fc-about-us-hero__play-btn--playing');
        btn.classList.add('fc-about-us-hero__play-btn--paused');
      }
    }

    wrapper.addEventListener('click', toggleVideo);

    video.addEventListener('ended', function () {
      video.style.display = 'none';
      btn.classList.remove('fc-about-us-hero__play-btn--playing');
      btn.classList.remove('fc-about-us-hero__play-btn--paused');
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hoe-werkt-het"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const video = document.querySelector('[data-video-element]');
    let videoLoaded = false;
    const playBtn = document.querySelector('.how-it-works__video-container .play-button-overlay');

    playBtn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      
      playVideo();
    });
    
    // Click on video to pause/play
    video.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      
      if (video.paused) {
        playVideo();
      } else {
        pauseVideo();
      }
    });
    
    // Show play button when video pauses or ends
    video.addEventListener('pause', () => {
      playBtn.classList.remove('hidden');
    });
    
    video.addEventListener('ended', () => {
      playBtn.classList.remove('hidden');
    });
    
    // iOS: Preload metadata when video container is visible
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting && !videoLoaded) {
            loadVideo(entry.target);
          }
        });
      }, {
        rootMargin: '50px'
      });
      
      observer.observe(video);
    }
    // iOS optimization: Load video metadata when container is clicked
    function loadVideo(video) {
      if (!videoLoaded) {
        video.load();
        videoLoaded = true;
      }
    }
    
    function playVideo() {
      loadVideo(video);
      // Unmute before playing (iOS requirement)
      video.muted = false;
      
      const playPromise = video.play();
      
      if (playPromise !== undefined) {
        playPromise
          .then(() => {
            // Video started playing
            playBtn.classList.add('hidden');
          })
          .catch((error) => {
            // Auto-play was prevented, show play button
            console.log('Video play prevented:', error);
            playBtn.classList.remove('hidden');
          });
      }
    }
    
    function pauseVideo() {
      video.pause();
      playBtn.classList.remove('hidden');
    }
    
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-page-carousel"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var swiper = new Swiper(".home-page-carousel", {
      centeredSlides: true,
      pagination: {
        el: ".home-page-carousel .swiper-pagination",
      },
    });
  });
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-recommended-products"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    var recommendedProductsSwiper = null;
    var recommendedProductsSliderEl = document.querySelector(".pdp-recommended-products__slider .swiper");
    if (!recommendedProductsSliderEl) return;

    function initSwiper() {
      // Only initialize Swiper on mobile (768px and below)
      if (window.innerWidth <= 768) {
        // Destroy existing Swiper if it exists
        if (recommendedProductsSwiper) {
          recommendedProductsSwiper.destroy(true, true);
          recommendedProductsSwiper = null;
        }
        
        recommendedProductsSwiper = new Swiper(recommendedProductsSliderEl, {
          slidesPerView: 'auto',
          spaceBetween: 24,
          freeMode: false,
          pagination: {
            el: '.pdp-recommended-products__slider .swiper-pagination',
            clickable: true,
          },
          navigation: {
            nextEl: '.pdp-recommended-products__slider .swiper-button-next',
            prevEl: '.pdp-recommended-products__slider .swiper-button-prev',
          },
        });
      } else {
        // Destroy Swiper if window is resized to desktop
        if (recommendedProductsSwiper) {
          recommendedProductsSwiper.destroy(true, true);
          recommendedProductsSwiper = null;
        }
      }
    }
    
    // Initialize on load
    initSwiper();
    
    // Re-initialize on resize
    let resizeTimer;
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function() {
        initSwiper();
      }, 250);
    });
    
  });

  } catch(e) { console.error(e); }
})();
})();
